// Shared Lottie animation loader with proper timing and duplicate prevention
window.loadLottieAnimations = function() {
  // Check if lottie is available
  if (typeof lottie === 'undefined') {
    console.warn('Lottie library not loaded yet, retrying...');
    setTimeout(window.loadLottieAnimations, 100);
    return;
  }

  // List of all possible Lottie containers
  const containers = [
    'lottie-workspace',
    'lottie-pass',
    'lottie-meeting-room',
    'lottie-remote-work',
    'lottie-coffee',
    'lottie-conference',
    'lottie-chair',
    'lottie-printer',
    'lottie-running',
    'lottie-beach',
    'lottie-sea',
    'lottie-room'
  ];

  // Icon path mapping
  const iconPaths = {
    'lottie-workspace': '/icons/workspace.json',
    'lottie-pass': '/icons/pass.json',
    'lottie-meeting-room': '/icons/meeting-room.json',
    'lottie-remote-work': '/icons/remote-work.json',
    'lottie-coffee': '/icons/coffee.json',
    'lottie-conference': '/icons/conference-room.json',
    'lottie-chair': '/icons/office-chair.json',
    'lottie-printer': '/icons/printer.json',
    'lottie-running': '/icons/running.json',
    'lottie-beach': '/icons/beach.json',
    'lottie-sea': '/icons/sea.json',
    'lottie-room': '/icons/room.json'
  };

  // Load each animation if container exists and hasn't been loaded yet
  containers.forEach(containerId => {
    const container = document.getElementById(containerId);
    if (container && !container.dataset.lottieLoaded) {
      try {
        // Mark as loaded before loading to prevent duplicates
        container.dataset.lottieLoaded = 'true';
        
        lottie.loadAnimation({
          container: container,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: iconPaths[containerId]
        });
      } catch (error) {
        console.error(`Failed to load Lottie animation for ${containerId}:`, error);
        // Reset the flag if loading failed
        delete container.dataset.lottieLoaded;
      }
    }
  });
};

// Load animations when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.loadLottieAnimations);
} else {
  // DOM already loaded
  window.loadLottieAnimations();
}

// Also listen for Turbo navigation events (if using Turbo/Hotwire)
document.addEventListener('turbo:load', window.loadLottieAnimations);
document.addEventListener('turbo:render', window.loadLottieAnimations);
